import { render, staticRenderFns } from "./DashboardEstimateProfitNumberDisplayer.vue?vue&type=template&id=ff26d116"
import script from "./DashboardEstimateProfitNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./DashboardEstimateProfitNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports